export default {
  title: 'Booking notifications',
  label: 'Where should we send reservation booking notifications?',
  placeholder: 'e.g. bookings@yourrestaurant.com',
  helper:
    "Any email works — it doesn't need a dashboard login. You can change it or add more later in Reservations → Settings → Notifications & Confirmation.",
  errors: {
    required: 'Add an email so booking notifications reach you.',
    invalid: 'Enter a valid email, like name@restaurant.com.',
  },
};
